<template>
	<div>
		{{ event.event }}
	</div>
</template>

<script>
export default {
	name: 'VehicleEventsItem',
	props: {
		event: Object
	}
};
</script>

<style lang="scss" scoped></style>
